var _circle, _circle2, _circle3, _circle4, _path, _ellipse, _rect, _path2, _path3, _rect2, _polygon, _polygon2, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _polygon3, _rect10, _rect11, _polygon4, _polygon5, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _polygon6, _polygon7, _polygon8, _path4, _circle13, _rect21, _path5, _rect22, _circle14, _circle15, _path6, _path7, _rect23, _rect24, _rect25, _polygon9, _path8, _polygon10, _path9, _path10, _polygon11, _path11, _path12, _path13, _polygon12, _path14, _path15, _path16, _polygon13, _path17, _polygon14, _path18, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 5320 3547",
    viewBox: "0 0 5320 3547",
    id: "finance",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1626.67,
    cy: 2355.58,
    r: 1012.32,
    fill: "#C3E8F8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1874.45,
    cy: 1147.55,
    r: 936.59,
    fill: "#C3E8F8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3175.37,
    cy: 1296.22,
    r: 936.59,
    fill: "#C3E8F8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3758.18,
    cy: 2315.89,
    r: 985.01,
    fill: "#C3E8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B81D6",
    d: "M2976.11 842.98c1.13-10.24 1.71-20.64 1.71-31.18 0-22.89-2.73-45.15-7.87-66.45l55.36-10.09-119.77-208.64-46.63 55.35c-24.6-17.36-52.11-30.83-81.65-39.52l25.45-71.4h-239.55l29.01 81.38c-26.94 11.21-51.75 26.55-73.66 45.22l-54.62-64.83-119.77 208.64 81.16 14.8c-3.58 17.95-5.47 36.53-5.47 55.54 0 11.34.67 22.51 1.97 33.5l-74.1 13.51 119.77 208.64 41.87-49.69c23.29 21.69 50.27 39.43 79.89 52.16l-18.93 53.1h239.55l-16.77-47.04c31.8-11.48 60.93-28.6 86.19-50.16l29.84 35.42 119.77-208.64L2976.11 842.98zM2686.5 999.73c-111.31 0-201.54-90.75-201.54-202.7 0-111.95 90.23-202.7 201.54-202.7s201.54 90.75 201.54 202.7C2888.04 908.98 2797.81 999.73 2686.5 999.73zM4326.39 1371.67c1.13-10.24 1.71-20.64 1.71-31.18 0-22.89-2.73-45.15-7.87-66.45l55.36-10.09-119.77-208.64-46.63 55.35c-24.6-17.36-52.11-30.83-81.65-39.52l25.45-71.4h-239.55l29.01 81.38c-26.94 11.21-51.75 26.55-73.66 45.22l-54.62-64.83-119.77 208.64 81.16 14.8c-3.58 17.95-5.47 36.53-5.47 55.54 0 11.34.67 22.51 1.97 33.5l-74.1 13.51 119.77 208.64 41.87-49.69c23.29 21.69 50.27 39.43 79.89 52.16l-18.93 53.1h239.55l-16.77-47.04c31.8-11.48 60.93-28.6 86.19-50.16l29.84 35.42 119.77-208.64L4326.39 1371.67zM4036.78 1528.42c-111.31 0-201.54-90.75-201.54-202.7 0-111.95 90.23-202.7 201.54-202.7 111.31 0 201.54 90.75 201.54 202.7C4238.32 1437.66 4148.08 1528.42 4036.78 1528.42zM1703.7 1292.18c1.61-14.55 2.44-29.32 2.44-44.3 0-32.52-3.9-64.14-11.25-94.4l79.1-14.34-171.13-296.4-66.62 78.63c-35.14-24.66-74.45-43.8-116.66-56.14l36.37-101.43H1113.7l41.45 115.62c-38.49 15.93-73.94 37.71-105.24 64.24l-78.04-92.1-171.13 296.4 115.95 21.02c-5.12 25.51-7.81 51.89-7.81 78.9 0 16.1.96 31.98 2.82 47.58l-105.87 19.19 171.13 296.4 59.82-70.59c33.28 30.81 71.83 56.01 114.14 74.1l-27.05 75.43h342.25l-23.96-66.82c45.44-16.31 87.05-40.62 123.15-71.26l42.64 50.32 171.13-296.4L1703.7 1292.18zM1289.92 1514.86c-159.03 0-287.96-128.92-287.96-287.96s128.92-287.96 287.96-287.96 287.96 128.92 287.96 287.96S1448.95 1514.86 1289.92 1514.86zM2202 517c1.13-10.24 1.72-20.64 1.72-31.18 0-22.89-2.74-45.15-7.92-66.45l55.68-10.09-120.46-208.64-46.9 55.35c-24.74-17.36-52.41-30.83-82.12-39.52l25.6-71.4h-240.92l29.18 81.38c-27.09 11.21-52.05 26.55-74.08 45.22l-54.93-64.83-120.46 208.64 81.62 14.8c-3.61 17.95-5.5 36.53-5.5 55.54 0 11.34.68 22.51 1.98 33.5l-74.52 13.51 120.46 208.64 42.11-49.69c23.43 21.69 50.56 39.43 80.35 52.16l-19.04 53.1h240.92L2017.9 750c31.98-11.48 61.28-28.6 86.69-50.16l30.01 35.42 120.46-208.64L2202 517zM1910.72 673.74c-111.95 0-202.7-90.75-202.7-202.7 0-111.95 90.75-202.7 202.7-202.7s202.7 90.75 202.7 202.7C2113.42 582.99 2022.67 673.74 1910.72 673.74z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2660,
    cy: 3141.23,
    fill: "#A3A4A4",
    rx: 2083.19,
    ry: 260.71
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 690.14,
    height: 847.5,
    x: 2341.43,
    y: 2326.79,
    fill: "#0F3772"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#269AFF",
    d: "M3774.46,861.48H1598.54c-121.22,0-219.48,98.27-219.48,219.48v1240.99 c0,121.22,98.27,219.48,219.48,219.48h2175.92c121.22,0,219.48-98.27,219.48-219.48V1080.97 C3993.94,959.75,3895.68,861.48,3774.46,861.48z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3712.33,901.1H1660.67c-114.3,0-206.95,92.66-206.95,206.95v1170.13 c0,114.3,92.66,206.95,206.95,206.95h2051.67c114.3,0,206.95-92.66,206.95-206.95V1108.05 C3919.29,993.75,3826.63,901.1,3712.33,901.1z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1328.36,
    height: 855.63,
    x: 2514.94,
    y: 990.2,
    fill: "#C6E4FF"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2F95E9",
    points: "2514.94 1601.32 2686.5 1467.17 2802.24 1601.32 3015.88 1372.77 3154.99 1601.32 3492.85 1283.34 3651.84 1601.32 3843.29 1487.04 3843.29 1845.83 2514.94 1845.83"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2370AF",
    points: "2686.5 1467.17 2514.94 1845.83 2514.94 1601.32"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2795.81,
    cy: 1591.38,
    r: 46.58,
    fill: "#184B75"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3009.45,
    cy: 1371.43,
    r: 46.58,
    fill: "#184B75"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 3158.5,
    cy: 1597.5,
    r: 46.58,
    fill: "#184B75"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3493.87,
    cy: 1283.34,
    r: 46.58,
    fill: "#184B75"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3650.37,
    cy: 1586.41,
    r: 46.58,
    fill: "#184B75"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2686.5,
    cy: 1467.17,
    r: 46.58,
    fill: "#184B75"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2686.5,
    cy: 1467.17,
    r: 46.58,
    fill: "#184B75"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 2686.5,
    cy: 1467.17,
    r: 46.58,
    fill: "#184B75"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1328.36,
    height: 69.56,
    x: 2514.94,
    y: 1914.33,
    fill: "#C6E4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 461.3,
    height: 66.63,
    x: 2015.51,
    y: 1091.46,
    fill: "#C6E4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 461.3,
    height: 66.63,
    x: 2015.51,
    y: 1200.01,
    fill: "#C6E4FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 461.3,
    height: 66.63,
    x: 2008.88,
    y: 1480.43,
    fill: "#C6E4FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 461.3,
    height: 66.63,
    x: 2008.88,
    y: 1374.26,
    fill: "#C6E4FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1328.36,
    height: 69.56,
    x: 2514.94,
    y: 2060.07,
    fill: "#C6E4FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 833.84,
    height: 69.56,
    x: 3009.45,
    y: 2215.74,
    fill: "#C6E4FF"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBD362",
    points: "1532.53 1291.69 1736.01 1021.56 1939.48 1291.69"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 406.94,
    height: 253.42,
    x: 1532.54,
    y: 1291.7,
    fill: "#FBD362"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 260.73,
    height: 365.41,
    x: 1605.64,
    y: 1096.21,
    fill: "#FCFCFC"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#BC9E4A",
    points: "1532.53 1291.69 1605.64 1291.69 1605.64 1342.87"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#BC9E4A",
    points: "1866.37 1291.69 1939.48 1291.69 1866.37 1342.87"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 233.72,
    height: 13.1,
    x: 1619.15,
    y: 1175.45,
    fill: "#BAE1F2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 201.86,
    height: 12.85,
    x: 1650.13,
    y: 1220.48,
    fill: "#5EBBE4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 14.31,
    height: 12.85,
    x: 1619.52,
    y: 1220.48,
    fill: "#5EBBE4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 201.86,
    height: 12.85,
    x: 1650.13,
    y: 1261.69,
    fill: "#5EBBE4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 14.31,
    height: 12.85,
    x: 1619.52,
    y: 1261.69,
    fill: "#5EBBE4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 14.31,
    height: 12.85,
    x: 1619.52,
    y: 1302.9,
    fill: "#5EBBE4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 201.86,
    height: 12.85,
    x: 1652.48,
    y: 1302.9,
    fill: "#5EBBE4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 14.31,
    height: 12.85,
    x: 1619.52,
    y: 1342.87,
    fill: "#5EBBE4"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 201.86,
    height: 12.85,
    x: 1652.48,
    y: 1342.87,
    fill: "#5EBBE4"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBD362",
    points: "1939.49 1291.7 1939.49 1545.11 1532.54 1545.11 1532.54 1291.7 1652.08 1375.37 1659.52 1380.58 1736.01 1434.12 1816.09 1378.08 1816.11 1378.06 1823.54 1372.85"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#BC9E4A",
    points: "1666.1 1386.89 1543.99 1545.11 1532.54 1545.11 1532.54 1530.27 1652.08 1375.37 1652.93 1374.26 1659.52 1380.58"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#BC9E4A",
    points: "1939.49 1529.87 1939.49 1545.11 1928.23 1545.11 1809.42 1384.2 1816.09 1378.08 1816.11 1378.06 1822.83 1371.88 1823.54 1372.85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#84D1EF",
    d: "M1746.54,1163.82c-4.39,2.58-8.85,3.56-14.2,3.56c-13.08,0-24.17-10.67-24.17-27.75 c0-18.32,11.4-34.15,29.11-34.15c13.88,0,23.21,10.85,23.21,25.7c0,13.34-6.7,21.17-14.2,21.17c-3.19,0-6.14-2.4-5.9-7.83 h-0.32c-2.79,5.25-6.46,7.83-11.25,7.83c-4.63,0-8.61-4.18-8.61-11.21c0-11.03,7.82-21.08,18.9-21.08 c3.43,0,6.46,0.8,8.53,1.87l-2.71,16.1c-1.2,6.76-0.24,9.87,2.39,9.96c4.07,0.09,8.61-5.96,8.61-16.28 c0-12.9-6.94-22.15-19.3-22.15c-13,0-23.93,11.47-23.93,29.53c0,14.85,8.69,24.01,20.5,24.01c4.55,0,8.77-1.07,12.04-3.11 L1746.54,1163.82z M1742.15,1125.4c-0.8-0.27-2.15-0.62-3.99-0.62c-7.02,0-12.68,7.38-12.68,16.01 c0,3.91,1.75,6.76,5.26,6.76c4.63,0,8.85-6.58,9.73-12.1L1742.15,1125.4z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1944.98,
    cy: 1301.35,
    r: 70.53,
    fill: "#F7725B"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 71.27,
    height: 9.27,
    x: 1910.72,
    y: 1316.45,
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M1952.54,1255.27h-12.36c-11.18,0-20.24,10.49-20.24,23.43v37.74h52.83v-37.74 C1972.78,1265.76,1963.72,1255.27,1952.54,1255.27z"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 5.87,
    height: 22.25,
    x: 1943.42,
    y: 1325.72,
    fill: "#F9F9F9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1948.06,
    cy: 1255.73,
    r: 6.33,
    fill: "#F9F9F9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1797.09,
    cy: 2017.53,
    r: 280.18,
    fill: "#F7725B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BAAFC",
    d: "M1797.09,2017.53l92.15,264.6c-29.63,10.32-60.78,15.59-92.15,15.59 c-153.7,0-280.18-126.48-280.18-280.18s126.48-280.18,280.18-280.18s280.18,126.48,280.18,280.18H1797.09z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC645",
    d: "M1797.09,2017.53l-251-124.52c47.23-95.2,144.72-155.67,251-155.67 c153.7,0,280.18,126.48,280.18,280.18H1797.09z"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 132.49,
    height: 132.49,
    x: 2134.59,
    y: 1737.35,
    fill: "#FFC645"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 132.49,
    height: 132.49,
    x: 2134.59,
    y: 1927.58,
    fill: "#4BAAFC"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 132.49,
    height: 132.49,
    x: 2134.59,
    y: 2129.62,
    fill: "#F7725B"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0F3772",
    points: "2686.5 2917.62 1470.38 3202.48 3902.62 3202.48"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDAD9F",
    d: "M3674.86,2574.73c0,0,2.38,60.35-7.5,61.02c-9.88,0.67-11.53-26.24-11.53-26.24 s-27.81,45.13-33.67,40.62c-5.85-4.51,11.89-35.1,11.89-35.1s-22.14,39.25-28.18,35.42c-6.04-3.83,14.09-35.09,14.09-35.09 s-20.67,29.09-27.63,24.74c-6.95-4.35,15.55-28.08,15.55-28.08s-15.73,13.87-20.13,7.36c-4.39-6.52,55.62-53.16,55.62-53.16 L3674.86,2574.73z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDAD9F",
    points: "3895.43 2155.6 3896.69 2247.32 3850.05 2267.47 3826.7 2244.69 3828.39 2180.61"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDAD9F",
    d: "M3896.33,2156.89c0,0-48.44,54.53-73.79,31.68s-25.07-35.7-25.41-56.39 c-0.34-20.69,9.46-64.85,41.91-68.55c32.45-3.71,55.94,66.7,55.94,66.7s13.69-13.71,22.81-1.92 c9.13,11.8,0.84,27.39-6.93,28.32C3903.09,2157.66,3896.33,2156.89,3896.33,2156.89z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#19365E",
    d: "M3838.53,2080.92c0,0-12.93,6.01-13.69,17.6c-1.63,24.96-27.32,32.27-25.35,47.25 c4.9,37.32,28.9,46.06,28.9,46.06l-1.35,38.19l-2.03-16.16c0,0-8.62,10.65-17.41,12.2c-8.79,1.54-8.79,1.54-8.79,1.54 l9.29-13.59c0,0-8.11,4.94-17.24,8.03c-9.13,3.09-9.13,3.09-9.13,3.09s5.75-7.87,7.77-12.35c2.03-4.48,2.03-4.48,2.03-4.48 s-16.01,13.32-28.18,14.59c-12.17,1.27-12.17,1.27-12.17,1.27s18.72-12.93,13.31-40.41c-5.41-27.48-4.73-42.31,7.44-52.8 c12.17-10.5,7.44-46.01,14.87-52.8c7.44-6.79,25.69-10.81,25.69-10.81s4.39-21.92,31.09-25.01c26.7-3.09,36.5,8.34,36.5,8.34 s23.66-7.72,38.53,19.45c14.87,27.17,13.52,29.78,22.65,40.06c9.13,10.28,5.75,42.39,5.75,42.39s26.02,19.45,26.7,35.51 s-26.7,42.92-26.7,42.92l4.22-25.32c0,0-13.01,22.08-22.65,25.32c-9.63,3.24-9.63,3.24-9.63,3.24s5.75-11.27,7.77-17.14 c2.03-5.87,2.03-5.87,2.03-5.87l-32.08,19.34l-0.37-73.69c0,0,25.35,5.1,24.84-17.83c-0.51-22.93-26.19-8.72-26.19-8.72 s-10.56,1.31-14.11-15.13s-5.32-29.88-13.69-31.03C3858.81,2083.01,3838.53,2080.92,3838.53,2080.92z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#253356",
    points: "3834.78 2457.63 3948.95 3188.77 4036.78 3188.77 3994.33 2446.53"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#253356",
    d: "M3877.95,2475.98l-26.35,712.79h-83.43c0,0-61.96-695.85,0-712.79 C3830.14,2459.04,3877.95,2475.98,3877.95,2475.98z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7FFFF",
    d: "M3896.47,2231.43c0,0-27.72,18.5-44.8,18.05c-17.08-0.45-24.78-20.6-24.78-20.6l-80.3,131.95 l12.69,115.9h133.68L3896.47,2231.43z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3AA75",
    d: "M3631.34,2563.3l62.2,26.74l43.03-91.72v-0.03l10.96-23.33l3.1-6.62c0,0,1.17-7.36,2.96-19.43 c0.46-3.15,0.98-6.62,1.52-10.37c3-20.68,7.01-49.69,10.42-79.01c0.65-5.58,1.27-11.17,1.85-16.72 c0.71-6.53,1.36-12.99,1.93-19.31c4.03-43.56,4.97-79.88-3.18-79.39c-1.31,0.08-2.57,0.18-3.75,0.32 c-16.58,1.78-22,7.91-22,7.91l-37.08,157.35L3631.34,2563.3z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E3AA75",
    points: "3896.47 2231.43 3855.64 2438.95 3871.74 2674.99 4015.92 2659.61 3986.49 2266.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDAD9F",
    d: "M3919.66,2632.31c0,0-26.59,38.78-23.42,46.14c3.17,7.36,22.44-16.27,22.44-16.27 s-7.56,51.49,0.98,53.27c8.54,1.78,12.2-38.56,12.2-38.56s-4.15,47.25,6.1,47.03c10.25-0.22,8.05-45.8,8.05-45.8 s1.95,36.22,12.2,37.56c10.25,1.34,0-37.56,0-37.56s2.68,19.28,10.49,18.61c7.81-0.67-7.56-56.84-7.56-56.84L3919.66,2632.31z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#AA8058",
    d: "M3940.35,2475.21l-33.4,153.04c-0.63,2.3,0.75,4.66,3.2,5.46l60.57,19.65c2.77,0.9,5.79-0.55,6.55-3.14 l32.33-110.1c0.45-1.54,0-3.19-1.2-4.35l-63.49-129.58C3942.16,2403.55,3941.32,2471.69,3940.35,2475.21z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3AA75",
    d: "M4000.55 2277.81l30.01 198.93-57.82 173.97-61.48-19.61 37.08-153.35c0 0-16.59-216.7 19.03-214.98C3995.06 2264.1 4000.55 2277.81 4000.55 2277.81zM3709.76 2664.18h58.56c0 0 9.06-123.4 14.1-187.45.1-1.44.22-2.84.33-4.21 1.04-13.24 1.88-23.53 2.4-29.01.68-7.29.77-16.55.49-26.45v-.17c-.85-31.58-5.3-69.72-5.6-72.31l-.01-.15 21.68-53.45c.03-.07.06-.12.07-.16l.53-1.35 24.6-60.61-.22.05-7.39 1.74-56.93 13.46c0 0 0 .11 0 .32.04 3.93-.06 43.24-20.9 80.05-21.95 38.78 11.72 122.04 11.72 122.04l-1.67 8.36-4 20.07-10.96 54.9L3709.76 2664.18z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#AA8058",
    points: "3896.95 2231.43 3929.07 2244.13 3904.27 2294.95 3907.19 2367.84 3857.75 2428.26"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#AA8058",
    d: "M3785.64,2417.08c0,0-24.96-50.58-19.83-69.31c5.12-18.72,24.4-51.71,24.4-51.71l7.33-60.11l29.17-7.07 l-24.94,61.95c-1.2,2.57-21.34,50.83-21.75,53.6L3785.64,2417.08z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#AA8058",
    points: "3747.51 2474.97 3736.56 2529.87 3756.56 2451.93 3768.33 2406.1 3755.6 2443.07 3753.58 2448.92 3751.51 2454.9 3736.56 2498.3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M4036.78 3188.77l-.83 66.07c-.19-1.77-170.7 0-170.7 0s-6.04-35 21.16-42.99c27.2-7.99 62.54-23.09 62.54-23.09H4036.78zM3851.6 3188.77l.08 66.07c-.19-1.77-165.97 0-165.97 0s-6.04-35 21.16-42.99 61.31-23.09 61.31-23.09H3851.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 828.38,
    height: 252.09,
    x: 970.32,
    y: 2487.42,
    fill: "#004980"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 828.38,
    height: 252.09,
    x: 1021.73,
    y: 2735.04,
    fill: "#BF3434"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 307.32,
    height: 147.88,
    x: 1077.19,
    y: 2785.01,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.73,
    height: 118.71,
    x: 1091.92,
    y: 2797.14
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.73,
    height: 118.71,
    x: 1091.92,
    y: 2797.14
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.73,
    height: 118.71,
    x: 1129.61,
    y: 2799.59
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.73,
    height: 118.71,
    x: 1164.71,
    y: 2799.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1721,
    cy: 2867.33,
    r: 57.3,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1721,
    cy: 2867.33,
    r: 54.59
  }), /*#__PURE__*/React.createElement("rect", {
    width: 307.32,
    height: 147.88,
    x: 1044.84,
    y: 2539.52,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.73,
    height: 118.71,
    x: 1062.89,
    y: 2554.11
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.73,
    height: 118.71,
    x: 1088.02,
    y: 2554.11
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.73,
    height: 118.71,
    x: 1114.88,
    y: 2554.11
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.73,
    height: 118.71,
    x: 1315.91,
    y: 2554.11
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.73,
    height: 118.71,
    x: 1289.92,
    y: 2554.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1677.68,
    cy: 2605.71,
    r: 57.3,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1677.68,
    cy: 2605.71,
    r: 54.59
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 830.96,
    height: 252.87,
    x: 993.45,
    y: 2987.13,
    fill: "#FFC645"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 308.28,
    height: 148.34,
    x: 1049.07,
    y: 3037.25,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.78,
    height: 119.08,
    x: 1063.85,
    y: 3049.42
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.78,
    height: 119.08,
    x: 1063.85,
    y: 3049.42
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.78,
    height: 119.08,
    x: 1101.66,
    y: 3051.88
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.78,
    height: 119.08,
    x: 1136.86,
    y: 3051.88
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1694.9,
    cy: 3119.82,
    r: 57.48,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1694.9,
    cy: 3119.82,
    r: 54.76
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 131.95,
    height: 348.71,
    x: 1557.36,
    y: 2127.43,
    fill: "#FF593A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 131.95,
    height: 241.12,
    x: 1342.11,
    y: 2235.02,
    fill: "#FF593A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 131.95,
    height: 196.03,
    x: 1123.77,
    y: 2290.55,
    fill: "#FF593A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 783.18,
    height: 11.87,
    x: 1006.53,
    y: 2476.14,
    fill: "#FF593A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 131.95,
    height: 203.15,
    x: 1100.03,
    y: 2272.99,
    fill: "#FF593A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 131.95,
    height: 260.11,
    x: 1313.63,
    y: 2216.03,
    fill: "#FF593A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 131.95,
    height: 368.79,
    x: 1525.08,
    y: 2107.35,
    fill: "#FF593A"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF593A",
    points: "1255.72 2290.55 1231.99 2272.99 1231.99 2290.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF593A",
    points: "1473.76 2235.25 1445.28 2216.27 1445.28 2235.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF593A",
    points: "1689.64 2127.83 1657.36 2107.76 1657.36 2127.83"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 1241.98,
    height: 187.86,
    x: 2158.36,
    y: 2384.25,
    fill: "#BF432C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1241.98,
    height: 735.26,
    x: 2158.36,
    y: 2565.64,
    fill: "#737EA3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1214.64,
    height: 187.86,
    x: 2081.12,
    y: 2384.25,
    fill: "#FF593A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1214.64,
    height: 735.26,
    x: 2081.12,
    y: 2565.64,
    fill: "#99A8D9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2212.47 2618.44h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2246.33 2633.61 2231.17 2618.44 2212.47 2618.44zM2390 2618.44h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87H2390c18.7 0 33.87-15.16 33.87-33.87v-53.68C2423.86 2633.61 2408.7 2618.44 2390 2618.44zM2397.17 2792.97h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2431.03 2808.13 2415.87 2792.97 2397.17 2792.97zM2397.17 2958.53h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2431.03 2973.69 2415.87 2958.53 2397.17 2958.53zM2399.06 3124.08h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2432.93 3139.25 2417.76 3124.08 2399.06 3124.08zM2563.86 3124.08h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2597.73 3139.25 2582.57 3124.08 2563.86 3124.08zM2717.76 3124.08h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2751.63 3139.25 2736.46 3124.08 2717.76 3124.08zM2889.75 3116.34h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2923.61 3131.51 2908.45 3116.34 2889.75 3116.34zM2555.65 2618.44h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2589.51 2633.61 2574.35 2618.44 2555.65 2618.44zM2557.77 2792.97h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2591.64 2808.13 2576.47 2792.97 2557.77 2792.97zM2563.86 2958.53h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2597.73 2973.69 2582.57 2958.53 2563.86 2958.53zM2721.3 2618.44h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2755.16 2633.61 2740 2618.44 2721.3 2618.44zM2721.3 2792.97h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2755.16 2808.13 2740 2792.97 2721.3 2792.97zM2721.3 2958.53h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2755.16 2973.69 2740 2958.53 2721.3 2958.53zM2900.42 2618.44h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2934.28 2633.61 2919.12 2618.44 2900.42 2618.44zM2890.16 2792.97h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2924.02 2808.13 2908.86 2792.97 2890.16 2792.97zM2890.16 2958.53h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2924.02 2973.69 2908.86 2958.53 2890.16 2958.53zM3072.54 2618.44h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C3106.4 2633.61 3091.24 2618.44 3072.54 2618.44zM3072.54 2792.97h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C3106.4 2808.13 3091.24 2792.97 3072.54 2792.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8891",
    d: "M3235 2618.44h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87H3235c18.7 0 33.87-15.16 33.87-33.87v-53.68C3268.87 2633.61 3253.71 2618.44 3235 2618.44zM3235 2792.97h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87H3235c18.7 0 33.87-15.16 33.87-33.87v-53.68C3268.87 2808.13 3253.71 2792.97 3235 2792.97zM3081.85 2958.53h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C3115.72 2973.69 3100.56 2958.53 3081.85 2958.53zM3241.84 2958.53h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C3275.71 2973.69 3260.55 2958.53 3241.84 2958.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2221.78 2792.97h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2255.65 2808.13 2240.49 2792.97 2221.78 2792.97zM2221.78 2958.53h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2255.65 2973.69 2240.49 2958.53 2221.78 2958.53zM2221.78 3124.08h-53.68c-18.7 0-33.87 15.16-33.87 33.87v53.68c0 18.7 15.16 33.87 33.87 33.87h53.68c18.7 0 33.87-15.16 33.87-33.87v-53.68C2255.65 3139.25 2240.49 3124.08 2221.78 3124.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC645",
    d: "M2205.61 2304.81h-21.34c-14.25 0-25.91 11.66-25.91 25.91v127.37c0 14.25 11.66 25.91 25.91 25.91h21.34c14.25 0 25.91-11.66 25.91-25.91v-127.37C2231.53 2316.47 2219.87 2304.81 2205.61 2304.81zM2370.07 2304.81h-21.34c-14.25 0-25.91 11.66-25.91 25.91v127.37c0 14.25 11.66 25.91 25.91 25.91h21.34c14.25 0 25.91-11.66 25.91-25.91v-127.37C2395.98 2316.47 2384.32 2304.81 2370.07 2304.81zM2541.36 2304.81h-21.34c-14.25 0-25.91 11.66-25.91 25.91v127.37c0 14.25 11.66 25.91 25.91 25.91h21.34c14.25 0 25.91-11.66 25.91-25.91v-127.37C2567.27 2316.47 2555.61 2304.81 2541.36 2304.81zM2714.44 2304.81h-21.34c-14.25 0-25.91 11.66-25.91 25.91v127.37c0 14.25 11.66 25.91 25.91 25.91h21.34c14.25 0 25.91-11.66 25.91-25.91v-127.37C2740.36 2316.47 2728.69 2304.81 2714.44 2304.81zM2893.56 2304.81h-21.34c-14.25 0-25.91 11.66-25.91 25.91v127.37c0 14.25 11.66 25.91 25.91 25.91h21.34c14.25 0 25.91-11.66 25.91-25.91v-127.37C2919.48 2316.47 2907.82 2304.81 2893.56 2304.81zM3065.68 2304.81h-21.34c-14.25 0-25.91 11.66-25.91 25.91v127.37c0 14.25 11.66 25.91 25.91 25.91h21.34c14.25 0 25.91-11.66 25.91-25.91v-127.37C3091.6 2316.47 3079.94 2304.81 3065.68 2304.81zM3218.83 2304.81h-21.34c-14.25 0-25.91 11.66-25.91 25.91v127.37c0 14.25 11.66 25.91 25.91 25.91h21.34c14.25 0 25.91-11.66 25.91-25.91v-127.37C3244.75 2316.47 3233.09 2304.81 3218.83 2304.81z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.93,
    height: 735.26,
    x: 3324.88,
    y: 2565.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.93,
    height: 735.26,
    x: 3367.73,
    y: 2565.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.25,
    height: 221.17,
    x: 3327.99,
    y: 2632.51,
    fill: "#FF593A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100.41,
    height: 221.17,
    x: 3369.63,
    y: 2895.18,
    fill: "#408FDD"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89.67,
    height: 89.67,
    x: 3359.39,
    y: 3172.32,
    fill: "#FFB12A"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F15936",
    d: "M2600.72,1234.72c0,0,516.51,134.4,774.02-173.41s257.51-307.81,257.51-307.81l-118.69-38.03 l345.5-206.31l29.84,338.09l-113.72-37.97c0,0-331.98,473.16-682.79,482.81S2600.72,1234.72,2600.72,1234.72z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3B81D6",
    d: "M3528,1716.4c0.25-2.29,0.38-4.63,0.38-6.99c0-5.13-0.61-10.12-1.76-14.89l12.41-2.26l-26.84-46.76 l-10.45,12.4c-5.51-3.89-11.68-6.91-18.3-8.86l5.7-16h-53.68l6.5,18.24c-6.04,2.51-11.6,5.95-16.51,10.13l-12.24-14.53 l-26.84,46.76l18.19,3.32c-0.8,4.02-1.23,8.19-1.23,12.45c0,2.54,0.15,5.05,0.44,7.51l-16.61,3.03l26.84,46.76l9.38-11.14 c5.22,4.86,11.27,8.84,17.9,11.69l-4.24,11.9h53.68l-3.76-10.54c7.13-2.57,13.65-6.41,19.32-11.24l6.69,7.94l26.84-46.76 L3528,1716.4z M3463.1,1751.52c-24.94,0-45.17-20.34-45.17-45.43c0-25.09,20.22-45.43,45.17-45.43s45.17,20.34,45.17,45.43 C3508.26,1731.19,3488.04,1751.52,3463.1,1751.52z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/full.0efc5150ebcd66ad21b47a197905c2d4.svg";
export { ForwardRef as ReactComponent };